import { render, staticRenderFns } from "./HighlightedSessions.vue?vue&type=template&id=187ed152&scoped=true"
import script from "./HighlightedSessions.vue?vue&type=script&lang=js"
export * from "./HighlightedSessions.vue?vue&type=script&lang=js"
import style0 from "./HighlightedSessions.vue?vue&type=style&index=0&id=187ed152&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "187ed152",
  null
  
)

export default component.exports